import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const aiFiltersContainer = style({
  display: 'flex',
  flexDirection: 'column',
  padding: space.s12,
  gap: space.s12,
  borderRadius: borderRadius.r8,
  border: `1px solid ${themeVars.container.border.default}`,
  backgroundColor: themeVars.container.primary.background.idle,
});

export const aiFiltersHeader = style({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: space.s16,
  flexWrap: 'wrap',
});

export const aiFiltersHeaderAside = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: space.s8,
});

export const aiFiltersHeaderTitle = style([
  typography.titleMd,
  {
    color: themeVars.link.idle,
  },
]);

export const aiFiltersFooter = style({
  display: 'flex',
  flexDirection: 'row',
  gap: space.s16,
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const aiFilterSelectItem = style({
  display: 'flex',
  gap: space.s12,
});

export const aiFilterSelectTrigger = style({
  width: '100%',
});

export const backButton = style({
  marginRight: space.s16,
});

export const createFilterButton = style({
  marginTop: space.s16,
  width: 'fit-content',
  alignSelf: 'center',
});

export const filterSelectContent = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: space.s2,
});

export const filterSelectName = style([
  typography.titleSm,
  {
    wordBreak: 'break-word',
  },
]);

export const filterSelectPrompt = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
    wordBreak: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
]);

export const aiFiltersLoading = style({
  height: '38px',
  display: 'flex',
  alignItems: 'center',
});
